import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";

import styles from "../../assets/css/pane.module.scss";
import RemittanceHome from "./RemittanceHome";
import RemittanceHomeLeftPane from "./RemittanceHomeLeftPane";
import RemittanceHomeRightPane from "./RemittanceHomeRightPane";

const RemittanceRateHome = () => {
  const { isMobileDevice } = useSelector((state) => state.app);
  if (isMobileDevice) {
    return (
      <Grid container>
        <div className={styles.mobileContainer}>
          <RemittanceHome isMobileDevice={isMobileDevice} />
        </div>
      </Grid>
    );
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={6} lg={5} xl={5}>
        <RemittanceHomeLeftPane />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={7} xl={7}>
        <RemittanceHomeRightPane>
          <RemittanceHome />
        </RemittanceHomeRightPane>
      </Grid>
    </Grid>
  );
};
export default RemittanceRateHome;
